import { IMAGES_PATH } from '../constants/routes';

const getImagePath = (icon: string): string => {
  return `${IMAGES_PATH}/${icon}.svg`;
};

export default getImagePath;
